(function () {
    'use strict';

    function productCard() {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/productCard.html',
            scope: {
                product: '=',
                actionText: '@',
                action: '&'
            },
            link: function (scope, element, attrs) {
                scope.toggleProductAccordion = function () {
                    scope.product.open = !scope.product.open;
                }
            }
        };
    }

    productCard.$inject = [];

    angular.module('ecap.common').directive('productCard', productCard);
})();